import DocumentMeta from "component/design-system/DocumentMeta";
import Head from "next/head";

interface Props {
  url: string;
}

function ArticleMetaHead(props: Props) {
  const {
    url, metaProps,
  } = props;

  return (
    <>
      <DocumentMeta {...metaProps} />
      <Head>
        {url && (
          <link rel="canonical" href={`https://partsavatar.ca${url}`} />
        )}
      </Head>
    </>
  );
}

export default ArticleMetaHead;
